export default "__VITE_ASSET__BzrjGC_M__"